// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2dfJb","colMaxWidth":"Table_colMaxWidth__2Gkz7"};